import { render, staticRenderFns } from "./ShowProperty.vue?vue&type=template&id=38e2a416"
import script from "./ShowProperty.vue?vue&type=script&lang=js"
export * from "./ShowProperty.vue?vue&type=script&lang=js"
import style0 from "./ShowProperty.vue?vue&type=style&index=0&id=38e2a416&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports